import React from 'react';
import { Box } from '@mui/material';
import appTheme from '../theme/appTheme.json';
import { ContentTypography, LAT_LNG_DECIMAL_PLACES, TitleTypography } from './RulerLegOverlayComponent';

export interface RulerMarkerOverlayComponentProps {
  latLng: google.maps.LatLng;
}

const RulerMarkerOverlayComponent: React.FC<RulerMarkerOverlayComponentProps> = (
  props: RulerMarkerOverlayComponentProps,
) => {
  const { latLng } = props;

  // Return the overlay component
  return (
    <Box
      sx={{
        backgroundColor: appTheme.mptPrimaryBackgroundColor,
        padding: '8px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box>
        <TitleTypography>Latitude: </TitleTypography>
        <ContentTypography>{latLng.lat().toFixed(LAT_LNG_DECIMAL_PLACES)}</ContentTypography>
      </Box>
      <Box>
        <TitleTypography>Longitude: </TitleTypography>
        <ContentTypography>{latLng.lng().toFixed(LAT_LNG_DECIMAL_PLACES)}</ContentTypography>
      </Box>
    </Box>
  );
};

export default RulerMarkerOverlayComponent;
